import { UserEntity } from '../user/user'

export enum CardTypeEnum {
  EMPTY = 'EMPTY',
  CUSTOMER = 'CUSTOMER',
}

export type CardEntity = {
  id: string
  driverPhone: string
  driverName: string
  licensePlate: string
  availableBalance: number
  accountsPayable: number
  debtLimit: number
  limitSetDate: number
  initialDebt: number
  createdDate: number
  customer: UserEntity
  active: boolean
  creator: UserEntity
}

export type CardFilter = {
  accountsPayableFrom?: number
  accountsPayableTo?: number
  availableBalanceFrom?: number
  availableBalanceTo?: number
  statuses: string[]
  customerName: string
  pageIndex: number
  pageSize: number
}
